













import {Component, Vue, Watch} from 'vue-property-decorator';
import PageHeader from '@/shared/components/pageHeader/PageHeader.vue';
import {Action, Getter, Mutation} from 'vuex-class';
import {LOAD_FLOW_LIST_OPTIONS} from '@/store/reports/actionTypes';
import {SET_REPORTING_FLOW} from '@/store/reports/mutationTypes';
import {FlowListOption} from '@/features/reports/models';
import FlowIcon from 'vue-material-design-icons/Waves.vue';

@Component({
	components: {
		PageHeader,
		FlowIcon
	}
})
export default class FlowReportFilters extends Vue {
	@Action(LOAD_FLOW_LIST_OPTIONS) public loadFlows: any;
	@Mutation(SET_REPORTING_FLOW) public setFlowForReports: (flowId: string) => void;
	@Getter public reportFlowsOptions!: FlowListOption[];
	@Getter public selectedFlowId!: string;
	@Getter public isReportLoading!: boolean;

	public flowId = 'all';

	public created() {
		this.flowId = this.selectedFlowId;
	}

	@Watch('selectedFlowId')
	public async onFlowChange(newFlowId: string, previous: string) {
		this.flowId = newFlowId;
	}

	public mounted() {
		this.loadFlows();
	}
}
